// extracted by mini-css-extract-plugin
export var darkText = "Phone-module--darkText--12f62";
export var fadeInAnimation = "Phone-module--fadeInAnimation--aedc3";
export var iconPhone = "Phone-module--iconPhone--072be";
export var link = "Phone-module--link--30884";